import { render, staticRenderFns } from "./IconFolderDownloadOutline.vue?vue&type=template&id=68b1fcdc"
import script from "./IconFolderDownloadOutline.vue?vue&type=script&lang=js"
export * from "./IconFolderDownloadOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports